export default __webpack_public_path__ + "static/media/R7SR224.24e15d63.png";